import { connectedStore } from '../../store';
import actions from '../actions';

const resetGlobal = (globalElement) => {
  const store = connectedStore.get();
  store.dispatch(actions.resetGlobal(globalElement));
};

export default resetGlobal;
